import { render, staticRenderFns } from "./MergeDialog.vue?vue&type=template&id=83e6d740&"
import script from "./MergeDialog.vue?vue&type=script&lang=js&"
export * from "./MergeDialog.vue?vue&type=script&lang=js&"
import style0 from "./MergeDialog.vue?vue&type=style&index=0&id=83e6d740&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports